module.exports = __webpack_public_path__ + "img/tag-icon-2.7375bcbb.png";